
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, MenuItem, TextField } from "@mui/material";

import { asignarUbicacion } from "../store/slices/UbicacionSlice";

import { RootState } from "../store";
import { openSnackbar } from "../store/slices/SnackbarSlice";

import { CircularProgressIndicator } from "../components/CircularProgressIndicator";
import { BoxTurnos } from "../components/BoxTurnos";

import { DialogActionsStyle, DialogContentStyle } from "../styles/DialogStyle";

import { ActualizarConfiguracion, ConsultarConfiguracion, ConsultarTiposTurno, ConsultarUbicacionesActivas } from "../connections/comun/TurnosConnection";

import { TiposTurnoProps } from "../interfaces/turnos/TiposTurnoInterface";
import { UbicacionProps } from "../interfaces/turnos/UbicacionInterface";

interface Props {
    openDialog: boolean;
    handleCloseDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DialogConfiguracion = ( { openDialog, handleCloseDialog }: Props ) => {

    const dispatch = useDispatch();

    const { sistemaTurnos } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( true );
    const [loadingSave, setLoadingSave] = useState( false );
    const [notConfiguration, setNotConfiguration] = useState( false );

    const [tiposTurno, setTiposTurno] = useState<number[]>( [] );
    const [tiposTurnoArray, setTiposTurnoArray] = useState<TiposTurnoProps[]>( [] );
    const [tiposTurnoArrayTemp, setTiposTurnoArrayTemp] = useState<TiposTurnoProps[]>( [] );

    const [ubicacion, setUbicacion] = useState<number>(0);
    const [ubicacionArray, setUbicacionArray] = useState<UbicacionProps[]>([]);
    
    const handleChange = ( id: number, checked: boolean ) => {
     
        const newArray = tiposTurnoArray.map( ( elem ) => {
            if( elem.id === id ){
                elem.selected = checked;
            }
            return elem;
        });

        const tipos = newArray.filter( ( { selected } ) => selected === true );
        
        setTiposTurno( tipos.map( (elem) => elem.id ) );      
        setTiposTurnoArray( newArray );
    };

    const handleGuardarConfiguracion = async () => {

        setLoadingSave( true );

        await ActualizarConfiguracion({ usuario_id: sistemaTurnos, ubicacion_id: ubicacion, turnos_tipos_ids: tiposTurno }).then( resp => {

            const { success, message, data: dataResponse } = resp;

            if( success ){

                setTimeout(() => {

                    const { ubicacion } = dataResponse;
                    
                    dispatch( asignarUbicacion({ ubicacion: ubicacion }) );
                        
                    dispatch( openSnackbar({ message: message, variant: 'success' }));  
                    setLoadingSave( false );
                    handleCloseDialog( false );

                }, 700);

            }
            else {

                setTimeout(() => {                    
                    
                    dispatch( openSnackbar({ message: message, variant: 'warning' }));  
                    setLoadingSave( false );

                }, 700);
            }

        });

    }

    useEffect(() => {
      
        async function obtener(){

            await ConsultarUbicacionesActivas().then( resp => {
                setUbicacionArray( resp.data );
            });
        }

        if( openDialog ){
            obtener();
        }

    }, [ openDialog ])     
    
    useEffect(() => {

        async function obtener(){

            await ConsultarTiposTurno().then( resp => {

                if( resp.data ){    
                    setTiposTurnoArray( resp.data );
                    setTiposTurnoArrayTemp( resp.data );
                }
                
            });
        }

        if( openDialog ){
            obtener();
        }  

    }, [ openDialog ])    

    useEffect(() => {

        async function obtener(){

            setLoading( true );

            await ConsultarConfiguracion({ usuario_id: sistemaTurnos }).then( resp => {

                setTimeout(() => {
                    
                    if( resp.data ){    
    
                        const { ubicacion: ventanilla, turnos_tipos } = resp.data;        
    
                        if( ventanilla.id !== 0 ){
                            setUbicacion( ventanilla.id );
                        }
    
                        if( turnos_tipos?.length !== 0 ){
    
                            const newArray = tiposTurnoArrayTemp.map( ( elem ) => {
                                const findElem = turnos_tipos?.find( (e) => e.id === elem.id );
                                if( findElem ){
                                    elem.selected = true;
                                }
                                
                                return elem;
                            });
                            
                            setTiposTurno( newArray.map( (elem) => elem.id ) );  
                            setTiposTurnoArray( newArray );
                        }
    
                        setLoading( false );
                    }
                    else{                        
                        setLoading( false );
                    }

                }, 700);
                
            });
        }

        if( openDialog && sistemaTurnos !== 0 && ubicacionArray.length !== 0 && tiposTurnoArrayTemp.length !== 0 ){      
            obtener();        
        }  
        else if( openDialog && sistemaTurnos === 0 ){
            setNotConfiguration( true );
        }

    }, [ openDialog, sistemaTurnos, ubicacionArray, tiposTurnoArrayTemp ])    

    return (        

        <Dialog         
            fullWidth
            maxWidth='sm'
            disableEscapeKeyDown
            open={ openDialog }
            onClose={ () => {} }
        >
            <DialogTitle>
                Configuración
            </DialogTitle>
            
            <DialogContent sx={ DialogContentStyle }>

                {
                    notConfiguration
                    ?
                        <BoxTurnos message="No se tienen configurado el sistema de turnos para este usuario" />
                    :
                        loading
                        ?
                            <Box sx={{ textAlign: 'center', alignItems: 'center', minHeight: 260 }}>
                                <CircularProgressIndicator mt={12} />
                            </Box>
                        :
                            <Grid container spacing={3} mt={1}>

                                <Grid size={{ xs: 12, md: 12 }}>

                                    <FormControl fullWidth>
                                    
                                        <TextField 
                                            label="Ubicación" 
                                            select
                                            slotProps={{
                                                inputLabel: {
                                                    shrink: true,
                                                },
                                            }} 
                                            value={ ubicacion }
                                            onChange={ (e) => setUbicacion( parseInt( e.target.value ?? '0' ) ) }
                                        >   
                                            <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>      
                                            {
                                                ubicacionArray?.map( ( { id, nombre, numero } ) => (
                                                    <MenuItem key={id} value={id}>{ nombre } - { numero }   </MenuItem>      
                                                ))
                                            }
                                        </TextField>

                                    </FormControl>   

                                </Grid>
                                
                                <Grid size={{ xs: 12, md: 12 }}>

                                    <FormControl>
                                        <FormLabel color="primary">Tipo de turno</FormLabel>

                                        <FormGroup sx={{ mt: 1 }}>

                                            {
                                                tiposTurnoArray.map( ( { id, nombre, selected } ) => (

                                                    <FormControlLabel
                                                        key={ id }
                                                        control={
                                                            <Checkbox checked={ selected ?? false } onChange={ (e) => handleChange( id, e.target.checked) } />
                                                        }
                                                        label={ nombre }
                                                    />

                                                ))
                                            }

                                        </FormGroup>

                                    </FormControl>
                                    
                                </Grid>
                     
                            </Grid>    
                }      
          
            </DialogContent>
           
            <DialogActions sx={ DialogActionsStyle }>

                <Button color="secondary" variant="text" onClick={ () => handleCloseDialog( false ) } disabled={ loadingSave }>
                    Cancelar
                </Button>

                <Button disabled={ ubicacion === 0 || tiposTurno.length === 0 } variant="contained" onClick={ handleGuardarConfiguracion } loading={ loadingSave }>
                    Guardar
                </Button>

            </DialogActions>

        </Dialog>       
       
    )
}